import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';


@Component({
  selector: 'app-input-comment.',
  templateUrl: './inputComment.component.html',
  styleUrls: ['./inputComment.component.scss']
})
export class InputCommentComponent {
  private tooltip = '';
  public isEdit = true;

  constructor() { }

  @Input() private value: string;
  @Output() commentChangeEvent = new EventEmitter<string>();
  @ViewChild('Input') private input: ElementRef;


  onSubmit(value: string) {
    this.commentChangeEvent.emit(value);
  }

  getTooltip(): string {
    return this.value.length > 27 ? this.value : '';
  }

  focusOut(value: string) {
    this.onSubmit(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/input-comment/inputComment.component.ts